import React from 'react';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { isAuthenticated } from '@shared/utils/auth';

const Component = () => <Outlet />;

export const Route = createFileRoute('/_auth')({
  beforeLoad: () => {
    if (!isAuthenticated()) {
      throw redirect({ to: '/signin' });
    }
  },
  component: Component,
});
